import { Method } from 'axios';
import { IWorkflow } from './interfaces';
import { Executable } from './executable';

export interface IExecuteWorkflowResponse {
  message: string;
}

export class ExecuteWorkflow
  extends Executable<IExecuteWorkflowResponse>
  implements Partial<IWorkflow>
{
  /**
   * The brand identifier.
   */
  public brandId?: number;

  /**
   * The program identifier.
   */
  public programId?: number;

  /**
   * The workflow identifier.
   */
  public workflowId?: string;

  /**
   * The pass identifier - provide either this, passSerialNo or uniqueId.
   */
  public passId?: number;

  /**
   * The pass unique identifier - provide either this, passId or passSerialNo.
   */
  public uniqueId?: string;

  /**
   * The pass serial number - provide either this, passId or uniqueId.
   */
  public passSerialNo?: string;

  public getMethod(): Method {
    return 'post';
  }

  public getResponse(apiResponse: any): IExecuteWorkflowResponse {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.programId) throw new Error('programId is required');
    if (!this.workflowId) throw new Error('workflowId is required');
    if (!this.passId && !this.passSerialNo && !this.uniqueId)
      throw new Error('Either passId, passSerialNo or uniqueId is required');
    return `${this.brandId}/programs/${this.programId}/workflows/${this.workflowId}/wallet-passes`;
  }

  constructor(input?: Partial<IWorkflow> & { brandId: number; programId: number }) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<IWorkflow> {
    return {
      ...(this.passId && { passId: this.passId }),
      ...(this.passSerialNo && { passSerialNo: this.passSerialNo }),
      ...(this.uniqueId && { key: this.uniqueId }),
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
